import { ol_Extent, ol_extent, ol_geom } from "@omnia/exports/openlayers"
import { Datalayer, DatalayerZone } from "../../../omnia"

type IMapTopologyService = omnia.map.IMapTopologyService
type IMapTopologyGeometry = omnia.map.IMapTopologyGeometry

export function deleteZones(layer: Datalayer, zones: DatalayerZone[], topo: IMapTopologyService) {

    const layerZones = layer.zones
        .filter(z => z.geometry instanceof ol_geom.Polygon)
        .sort((a, b) => a.area - b.area)

    const targets = zones
        .sort((a, b) => a.area - b.area)

    let filled = 0

    targets.forEach((z, index) => {

        if ((z.geometry instanceof ol_geom.Polygon) && (z.geometry.getLinearRingCount() == 1)) {

            const prev = targets.slice(0, index + 1)

            const others = layerZones.filter(z => prev.every(i => i != z))

            if (others.length > 0) {

                if (deleteInnerRingZone(z, others, topo)) {
                    filled++
                }

            }

        }

        layer.removeZone(z)

    })

    return (filled == zones.length)

}

function deleteInnerRingZone(zone: DatalayerZone, others: DatalayerZone[], topo: omnia.map.IMapTopologyService) {

    const poly = zone.geometry as ol_geom.Polygon

    const extent = zone.geometry.getExtent()

    const inner = { poly, extent }

    for (const o of others) {

        const match = checkPotentialMatch(inner, o, topo)

        if (match && (match.length > 0)) {

            const result = new ol_geom.Polygon(match.map(m => m.getCoordinates()))

            o.feature.setGeometry(result)

            return true

        }

    }

}

function checkPotentialMatch(
    inner: { poly: ol_geom.Polygon, extent: ol_Extent },
    outer: { geometry: ol_geom.Geometry },
    topo: {
        contains(outer: any, inner: any): boolean,
        difference(outer: any, others: any[]): IMapTopologyGeometry
    }) {

    const { poly, extent } = inner

    const oextent = outer.geometry.getExtent()

    if (!ol_extent.containsExtent(oextent, extent)) {
        return undefined
    }

    const opoly = outer.geometry as ol_geom.Polygon

    const rings = opoly.getLinearRings()
        .map((ring, index) => {

            if (!index) {

                return {
                    ring,
                    match: false,
                    diff: undefined
                }

            }

            const tmp = new ol_geom.Polygon([ring.getCoordinates()])

            if (!topo.contains(tmp, poly)) {

                return {
                    ring,
                    match: false,
                    diff: undefined
                }

            }

            const diff = topo.difference(tmp, [poly])

            if (!diff) {

                return {
                    ring,
                    match: true,
                    diff: 0
                }

            }

            const area = diff.getArea() || 0

            return {
                ring,
                match: area < 100,
                diff: area
            }

        })

    const matches = rings.filter(r => r.match).length

    if (matches != 1) {
        return undefined
    }

    return rings.filter(r => !r.match).map(r => r.ring)

}
